module.exports = __webpack_public_path__ + "static/media/Messages.402dff32.png";